import { getDefaultKeys } from '@/utils/handleData.js'
import { setCheckButtons, setTableButtons } from '@/utils/getbuttons.js'

const fields = {
  navBar: (params) => {
    return (activeNav) => {
      var navBar = {}
      navBar.navTitle = '字段名称列表'
      if (activeNav === 'jobTitle') {
        navBar.queryFun =
          params.orgName === '甘肃大鹏鸟科技有限公司'
            ? 'dictionary/getJobTitle'
            : 'orgField/getOrgJobTitle'
      } else if (activeNav === 'disease') {
        navBar.queryFun = 'dictionary/getDisease'
      } else if (activeNav === 'business') {
        navBar.queryFun = 'dictionary/getBusiness'
      } else if (activeNav === 'goodsType') {
        navBar.queryFun = 'dictionary/getGoodsType'
      } else if (activeNav === 'structureModel') {
        navBar.queryFun = 'orgField/getStructureModel'
      } else if (activeNav === 'paperModel') {
        navBar.queryFun = 'dictionary/getCreatePaperModel'
      } else if (activeNav === 'eduContent') {
        navBar.queryFun = 'dictionary/getEduContent'
      } else if (activeNav === 'standardRates') {
        navBar.queryFun = 'dictionary/getStandardRates'
      } else if (activeNav === 'evaluationModule') {
        navBar.queryFun = 'dictionary/getEvaluationModule'
      } else if (activeNav === 'department') {
        navBar.queryFun = 'dictionary/getDepartment'
      } else if (activeNav === 'fieldMenu') {
        navBar.queryFun = 'dictionary/getSysFieldMenu'
      }
      return navBar
    }
  },
  jobTitle: {
    name: 'jobTitle',
    theme: '岗位职务',
    componentTypes: ['navigate', 'navBar', 'check', 'tables', 'dialogForm'], // 该页面包含的组件名称，用于判断是否返回页面渲染参数
    getListFun: (params) => {
      return params.orgName === '甘肃大鹏鸟科技有限公司'
        ? 'dictionary/getJobTitle'
        : 'orgField/getOrgJobTitle'
    },
    deleteFun: (params) => {
      return params.orgName === '甘肃大鹏鸟科技有限公司'
        ? 'dictionary/deleteJobTitle'
        : 'orgField/deleteOrgJobTitle'
    },
    detailPage: [
      {
        code: 'add',
        type: 'dialogForm',
        name: 'jobTitle'
      },
      {
        code: 'edit',
        type: 'dialogForm',
        name: 'jobTitle',
        checkType: 'useRowData'
      }
    ],
    headButtons: (params) => {
      if (params.orgName === '甘肃大鹏鸟科技有限公司') {
        return setCheckButtons(['新增'])
      }
      return setCheckButtons(['新增', '同步系统默认', '重置为系统默认'])
    },
    rowData: (params) => {
      var jobTitles = []
      if (
        params.orgName === '甘肃大鹏鸟科技有限公司' &&
        params.dictionarys.jobTitle
      ) {
        jobTitles = params.dictionarys.jobTitle
      } else if (
        params.orgName !== '甘肃大鹏鸟科技有限公司' &&
        params.orgFields.jobTitle
      ) {
        params.orgFields.jobTitle.forEach((item) => {
          if (item.children && item.children.length) {
            item.children.forEach((org) => {
              org.type = item.name
            })
          }
          getDefaultKeys(item, '', jobTitles)
        })
      }
      return jobTitles
    },
    columns: [
      { prop: 'code', label: '职务编码', width: '' },
      { prop: 'name', label: '职务名称', width: '' },
      { prop: 'type', label: '职务类型', width: '' },
      { prop: 'mark', label: '职责描述', width: '' },
      {
        label: '操作',
        buttons: setTableButtons(['编辑', '删除'])
      }
    ],
    jobTitle: {
      title: (params) => {
        return params.pageStatus === 'add'
          ? '新增岗位职务'
          : params.pageStatus === 'edit'
          ? '编辑岗位职务'
          : ''
      },
      addFun: (params) => {
        return params.orgName === '甘肃大鹏鸟科技有限公司'
          ? 'dictionary/addJobTitle'
          : 'orgField/addOrgJobTitle'
      },
      editFun: (params) => {
        return params.orgName === '甘肃大鹏鸟科技有限公司'
          ? 'dictionary/editJobTitle'
          : 'orgField/editOrgJobTitle'
      },
      getParentFun: (params) => {
        return params.orgName === '甘肃大鹏鸟科技有限公司'
          ? 'dictionary/getJobTitle'
          : 'orgField/getOrgJobTitle'
      },
      formParams: {
        projectUid: (params) => {
          return params.orgValue
        },
        uid: '',
        code: '',
        name: '',
        type: (params) => {
          return params.orgName === '甘肃大鹏鸟科技有限公司'
            ? ''
            : params.orgBuildType
            ? params.orgBuildType
            : '其他'
        },
        typeCode: (params) => {
          var typeCode = '999'
          if (params.orgBuildType === '建设单位') {
            typeCode = '001'
          } else if (params.orgBuildType === '总承包单位') {
            typeCode = '002'
          } else if (params.orgBuildType === '监理单位') {
            typeCode = '003'
          } else if (params.orgBuildType) {
            typeCode = '004'
          }
          return typeCode
        },
        mark: ''
      },
      formRules: {
        code: [
          {
            required: true,
            message: '请输入职务编码',
            trigger: 'blur'
          }
        ],
        name: [
          {
            required: true,
            message: '请输入职务名称',
            trigger: 'blur'
          }
        ],
        type: [
          {
            required: true,
            message: '请选择所属机构参建类型',
            trigger: 'blur'
          }
        ]
      },
      formData: [
        {
          key: 'code',
          label: '职务编码',
          type: 'input',
          span: 18
        },
        {
          key: 'name',
          label: '职务名称',
          type: 'input',
          span: 18
        },
        {
          key: 'type',
          label: '职务类型',
          type: 'select',
          disabled: (params) => {
            return params.orgName !== '甘肃大鹏鸟科技有限公司'
          },
          options: (params) => {
            var types = params.dictionarys.buildType
              ? JSON.parse(JSON.stringify(params.dictionarys.buildType))
              : []
            types.push({ value: '999', label: '其他' })
            return types
          },
          span: 18
        },
        {
          key: 'mark',
          label: '职责描述',
          type: 'input',
          span: 18
        }
      ]
    }
  },
  // 系统字段「职能部门」：始终维护系统字典 d_department（与工作台机构模板分离）
  department: {
    name: 'department',
    theme: '职能部门',
    componentTypes: ['navigate', 'navBar', 'check', 'tables', 'dialogForm'],
    headButtons: setCheckButtons(['新增']),
    detailPage: [
      {
        buttonName: '新增',
        type: 'dialogForm',
        name: 'department'
      },
      {
        buttonName: '编辑',
        type: 'dialogForm',
        name: 'department',
        checkType: 'useRowData'
      }
    ],
    getListFun: 'dictionary/getDepartment',
    deleteFun: 'dictionary/deleteDepartment',
    outListHeight: 240,
    rowData: (params) => {
      return params.dictionarys.department || []
    },
    columns: [
      { prop: 'code', label: '机构编码', width: '' },
      { prop: 'name', label: '机构名称', width: '' },
      { prop: 'type', label: '机构类型', width: '' },
      { prop: 'mark', label: '机构描述', width: '' },
      {
        label: '操作',
        buttons: setTableButtons(['编辑', '删除'])
      }
    ],
    department: {
      title: (params) => {
        return params.pageStatus === 'add'
          ? '新增职能部门'
          : params.pageStatus === 'edit'
          ? '编辑职能部门'
          : '职能部门'
      },
      addFun: 'dictionary/addDepartment',
      editFun: 'dictionary/editDepartment',
      getParentFun: 'dictionary/getDepartment',
      formParams: {
        uid: '',
        code: '',
        name: '',
        type: '',
        typeCode: '',
        mark: ''
      },
      formRules: {
        code: [
          {
            required: true,
            message: '请输入机构编码',
            trigger: 'blur'
          }
        ],
        name: [
          {
            required: true,
            message: '请输入机构名称',
            trigger: 'blur'
          }
        ],
        type: [
          {
            required: true,
            message: '请选择机构类型',
            trigger: 'change'
          }
        ]
      },
      formData: [
        {
          key: 'code',
          label: '机构编码',
          type: 'input',
          span: 18,
          offset: 3
        },
        {
          key: 'name',
          label: '机构名称',
          type: 'input',
          span: 18,
          offset: 3
        },
        {
          key: 'type',
          label: '机构类型',
          type: 'select',
          options: (params) => {
            var types = params.dictionarys.buildType
              ? JSON.parse(JSON.stringify(params.dictionarys.buildType))
              : []
            types.push({ value: '999', label: '其他' })
            return types
          },
          span: 18,
          offset: 3
        },
        {
          key: 'mark',
          label: '机构描述',
          type: 'input',
          span: 18,
          offset: 3
        }
      ]
    }
  },
  disease: {
    name: 'disease',
    theme: '重大病史',
    componentTypes: ['navigate', 'navBar', 'check', 'tables', 'dialogForm'], // 该页面包含的组件名称，用于判断是否返回页面渲染参数
    detailPage: [
      {
        code: 'add',
        type: 'dialogForm',
        name: 'disease'
      },
      {
        code: 'edit',
        type: 'dialogForm',
        name: 'disease',
        checkType: 'useRowData'
      }
    ],
    headButtons: setCheckButtons(['新增']),
    getListFun: 'dictionary/getDisease',
    deleteFun: 'dictionary/deleteDisease',
    rowData: (params) => {
      return params.dictionarys.isDisease
    },
    columns: [
      { prop: 'num', label: '数据编码', width: '' },
      { prop: 'type', label: '数据名称', width: '' },
      { prop: 'mark', label: '备注', width: '' },
      {
        label: '操作',
        buttons: setTableButtons(['编辑', '删除'])
      }
    ],
    disease: {
      title: (params) => {
        return params.pageStatus === 'add'
          ? '新增重大病史'
          : params.pageStatus === 'edit'
          ? '编辑重大病史'
          : ''
      },
      addFun: 'dictionary/addDisease',
      editFun: 'dictionary/editDisease',
      getParentFun: 'dictionary/getDisease',
      formParams: {
        uid: '',
        num: '',
        type: '',
        mark: ''
      },
      formRules: {
        num: [
          {
            required: true,
            message: '请输入数据编码',
            trigger: 'blur'
          }
        ],
        type: [
          {
            required: true,
            message: '请输入数据名称',
            trigger: 'blur'
          }
        ]
      },
      formData: [
        {
          key: 'num',
          label: '数据编码',
          type: 'input',
          span: 18
        },
        {
          key: 'type',
          label: '数据名称',
          type: 'input',
          span: 18
        },
        {
          key: 'mark',
          label: '备注',
          type: 'input',
          span: 18
        }
      ]
    }
  },
  business: {
    name: 'business',
    theme: '作业工种',
    componentTypes: ['navigate', 'navBar', 'check', 'tables', 'dialogForm'], // 该页面包含的组件名称，用于判断是否返回页面渲染参数
    detailPage: [
      {
        code: 'add',
        type: 'dialogForm',
        name: 'business'
      },
      {
        code: 'edit',
        type: 'dialogForm',
        name: 'business',
        checkType: 'useRowData'
      }
    ],
    headButtons: setCheckButtons(['新增']),
    getListFun: 'dictionary/getBusiness',
    deleteFun: 'dictionary/deleteBusiness',
    rowData: (params) => {
      var business = params.dictionarys.business
      if (business) {
        business.forEach((item) => {
          if (item.isSpecial === '1') {
            item.special = '是'
          } else {
            item.special = '否'
          }
        })
      }
      return business
    },
    columns: [
      { prop: 'num', label: '工种编码', width: '' },
      { prop: 'type', label: '工种名称', width: '' },
      {
        prop: 'special',
        label: '是否为特殊工种',
        tag: (params) => {
          return params.dictionarys.isFalse
        }
      },
      {
        label: '操作',
        buttons: setTableButtons(['编辑', '删除'])
      }
    ],
    business: {
      title: (params) => {
        return params.pageStatus === 'add'
          ? '新增作业工种'
          : params.pageStatus === 'edit'
          ? '编辑作业工种'
          : ''
      },
      addFun: 'dictionary/addBusiness',
      editFun: 'dictionary/editBusiness',
      getParentFun: 'dictionary/getBusiness',
      formParams: {
        uid: '',
        num: '',
        type: '',
        isSpecial: ''
      },
      formRules: {
        num: [
          {
            required: true,
            message: '请输入工种编码',
            trigger: 'blur'
          }
        ],
        type: [
          {
            required: true,
            message: '请输入工种名称',
            trigger: 'blur'
          }
        ],
        isSpecial: [
          {
            required: true,
            message: '请选择',
            trigger: 'blur'
          }
        ]
      },
      formData: [
        {
          key: 'num',
          label: '工种编码',
          type: 'input',
          span: 18
        },
        {
          key: 'type',
          label: '工种名称',
          type: 'input',
          span: 18
        },
        {
          key: 'isSpecial',
          label: '是否为特殊工种',
          type: 'select',
          options: (params) => {
            return params.dictionarys.isFalse
          },
          checkByValue: true,
          span: 18
        }
      ]
    }
  },
  goodsType: {
    name: 'goodsType',
    theme: '物资类型',
    componentTypes: ['navigate', 'navBar', 'check', 'tables', 'dialogForm'], // 该页面包含的组件名称，用于判断是否返回页面渲染参数
    detailPage: [
      {
        code: 'add',
        type: 'dialogForm',
        name: 'goodsType'
      },
      {
        code: 'edit',
        type: 'dialogForm',
        name: 'goodsType',
        checkType: 'useRowData'
      }
    ],
    headButtons: (params) => {
      if (params.orgName === '甘肃大鹏鸟科技有限公司') {
        return setCheckButtons(['新增'])
      }
      return setCheckButtons(['新增', '同步系统默认', '重置为系统默认'])
    },
    getListFun: 'dictionary/getGoodsType',
    deleteFun: 'dictionary/deleteGoodsType',
    indexColumn: true,
    rowData: (params) => {
      var goodsType = []
      if (params.dictionarys.goodsType) {
        params.dictionarys.goodsType.forEach((item) => {
          if (!item.children) {
            goodsType.push(item)
          } else {
            item.children.forEach((child) => {
              const specRows =
                child.specRows && child.specRows.length
                  ? child.specRows
                  : [{ uid: child.uid, model: child.model }]
              specRows.forEach((spec) => {
                goodsType.push(
                  Object.assign({}, child, {
                    uid: spec.uid,
                    model: spec.model,
                    goodsGroupName: item.goodsName
                  })
                )
              })
            })
          }
        })
      }
      return goodsType
    },
    columns: [
      { prop: 'goodsGroupName', label: '物资类型分组', width: '' },
      { prop: 'goodsName', label: '物资类型名称', width: '' },
      {
        prop: 'model',
        label: '规格型号',
        width: '260px'
      },
      {
        label: '操作',
        buttons: setTableButtons(['编辑', '删除'])
      }
    ],
    goodsType: {
      title: (params) => {
        return params.pageStatus === 'add'
          ? '新增物资类型'
          : params.pageStatus === 'edit'
          ? '编辑物资类型'
          : ''
      },
      addFun: 'dictionary/addGoodsType',
      editFun: 'dictionary/editGoodsType',
      getParentFun: 'dictionary/getGoodsType',
      formParams: {
        uid: '',
        goodsGroupUid: '',
        goodsGroupName: '',
        goodsName: '',
        model: ''
      },
      formRules: {
        goodsGroupName: [
          {
            required: true,
            message: '请输入或选择物资类型分组',
            trigger: 'change'
          }
        ],
        goodsName: [
          {
            required: true,
            message: '请输入物资类型名称',
            trigger: 'change'
          }
        ]
      },
      formData: [
        {
          key: 'goodsGroupName',
          label: '物资类型分组',
          type: 'select',
          options: (params) => {
            const groups =
              params.dictionarys && params.dictionarys.goodsType
                ? params.dictionarys.goodsType
                : []
            const goodsGroup = JSON.parse(
              JSON.stringify(groups)
            )
            goodsGroup.forEach((item) => {
              delete item.children
            })
            return goodsGroup
          },
          filterable: true,
          create: (params) => {
            return params.pageStatus === 'add' ? true : false
          },
          span: 18
        },
        {
          key: 'goodsName',
          label: '物资类型名称',
          type: 'select',
          filterable: true,
          clearable: true,
          create: true,
          placeholder: '请选择已有类型，或手动输入新类型',
          options: (params) => {
            const currentForm = params.formValues || {}
            const groupName = currentForm.goodsGroupName
            if (!groupName) return []
            const names = new Set()
            const groups =
              params.dictionarys && params.dictionarys.goodsType
                ? params.dictionarys.goodsType
                : []
            groups.forEach((group) => {
              if (group.goodsName !== groupName) return
              const children = group.children || []
              children.forEach((child) => {
                if (child.goodsName) names.add(child.goodsName)
              })
            })
            return Array.from(names).map((name) => ({
              label: name,
              value: name
            }))
          },
          span: 18
        },
        {
          key: 'model',
          label: '规格型号',
          type: 'input',
          placeholder: '已有类型请填写新规格；新类型可不填',
          span: 18
        }
      ]
    }
  },
  structureModel: {
    name: 'structureModel',
    theme: '工程结构模型',
    componentTypes: ['navigate', 'check', 'tables', 'dialogForm'], // 该页面包含的组件名称，用于判断是否返回页面渲染参数
    detailPage: [
      {
        code: 'add',
        type: 'dialogForm',
        name: 'structureModel'
      },
      {
        code: 'edit',
        type: 'dialogForm',
        name: 'structureModel',
        checkType: 'useRowData'
      }
    ],
    headButtons: (params) => {
      if (params.orgName === '甘肃大鹏鸟科技有限公司') {
        return setCheckButtons(['新增'])
      }
      return setCheckButtons(['新增', '同步系统默认', '重置为系统默认'])
    },
    getListFun: 'orgField/getStructureModel',
    deleteFun: 'orgField/deleteStructureModel',
    indexColumn: true,
    rowData: (params) => {
      var structureModel = []
      if (params.orgFields.structureModel) {
        structureModel = JSON.parse(
          JSON.stringify(params.orgFields.structureModel)
        )
        //structureModel.forEach((item) => {})
      }
      return structureModel
    },
    columns: [
      { prop: 'name', label: '工程结构模型名称', width: '' },
      { prop: 'info', label: '结构数据指标', overflow: false, width: '600px' },
      {
        prop: 'picStatus',
        label: '模型图',
        tag: [
          { label: '无模型图', type: 'danger' },
          { label: '有模型图', type: 'success' }
        ]
      },
      {
        label: '操作',
        buttons: setTableButtons(['编辑', '删除'])
      }
    ],
    structureModel: {
      title: (params) => {
        return params.pageStatus === 'add'
          ? '新增工程结构模型'
          : params.pageStatus === 'edit'
          ? '编辑工程结构模型'
          : ''
      },
      manualUpload: true,
      addFun: 'orgField/addStructureModel',
      editFun: 'orgField/editStructureModel',
      getParentFun: 'orgField/getStructureModel',
      formParams: {
        uid: '',
        orgUid: (params) => params.orgValue,
        name: '',
        sizes: [],
        image: '',
        fileLists: {
          image: []
        }
      },
      formRules: (params) => {
        var formRules = {}
        formRules.name = [
          {
            required: true,
            message: '请输入工程结构模型名称',
            trigger: 'blur'
          }
        ]
        if (params.formValues && params.formValues.sizes) {
          params.formValues.sizes.forEach((item, index) => {
            formRules['key' + (index + 1)] = [
              {
                required: true,
                message: '请输入英文字母或数字组成的键名',
                trigger: 'blur'
              },
              {
                pattern: /\w/g,
                message: '请输入英文字母或数字',
                trigger: 'blur'
              }
            ]
            formRules['label' + (index + 1)] = [
              {
                required: true,
                message: '请输入结构指标名称',
                trigger: 'blur'
              }
            ]
          })
        }
        return formRules
      },
      formData: (params) => {
        var formData = [
          {
            key: 'name',
            label: '工程结构模型名称',
            type: 'input',
            span: 24
          },
          {
            type: 'button',
            buttons: [
              { name: '添加结构指标', type: 'primary', icon: 'el-icon-plus' }
            ],
            span: 24
          },
          {
            key: 'image',
            label: '工程结构模型图',
            type: 'upload',
            autoUpload: false,
            limit: 1,
            span: 24
          }
        ]
        if (params.formValues && params.formValues.sizes) {
          params.formValues.sizes.forEach((item, index) => {
            const key = {
              key: 'key' + (index + 1),
              label: '指标' + (index + 1) + '键名',
              type: 'input',
              buttonIcon: 'el-icon-delete-solid',
              span: 12
            }
            const label = {
              key: 'label' + (index + 1),
              label: '指标' + (index + 1) + '名称',
              type: 'input',
              span: 12
            }
            const type = {
              key: 'type' + (index + 1),
              label: '指标' + (index + 1) + '类型',
              type: 'select',
              options: [
                { value: '1', label: '尺寸' },
                { value: '2', label: '混凝土' },
                { value: '3', label: '钢筋' },
                { value: '4', label: '其他' }
              ],
              span: 12
            }
            const value = {
              key: 'value' + (index + 1),
              label: '指标' + (index + 1) + '默认值',
              type: 'input',
              span: 12,
              number: true
            }
            const unit = {
              key: 'unit' + (index + 1),
              label: '指标' + (index + 1) + '单位',
              type: 'input',
              span: 12
            }
            formData.splice(-2, 1, key, label, type, value, unit, {
              type: 'button',
              buttons: [
                { name: '添加结构指标', type: 'primary', icon: 'el-icon-plus' }
              ],
              span: formData.length % 2 === 1 ? 12 : 24
            })
          })
        }
        return formData
      }
    }
  },
  paperModel: {
    name: 'paperModel',
    theme: '试卷模版',
    componentTypes: ['navigate', 'navBar', 'check', 'tables', 'dialogForm'], // 该页面包含的组件名称，用于判断是否返回页面渲染参数
    detailPage: [
      {
        code: 'add',
        type: 'dialogForm',
        name: 'paperModel'
      },
      {
        code: 'edit',
        type: 'dialogForm',
        name: 'paperModel',
        checkType: 'useRowData'
      }
    ],
    headButtons: (params) => {
      if (params.orgName === '甘肃大鹏鸟科技有限公司') {
        return setCheckButtons(['新增'])
      }
      return setCheckButtons(['新增', '同步系统默认', '重置为系统默认'])
    },
    getListFun: 'dictionary/getCreatePaperModel',
    deleteFun: 'dictionary/deleteCreatePaperModel',
    indexColumn: true,
    rowData: (params) => {
      return (
        params.dictionarys.createPaperTemplates ||
        params.dictionarys.createPaperModel ||
        []
      )
    },
    columns: [
      { prop: 'templateName', label: '模版名称', width: '' },
      { prop: 'rulesSummary', label: '题型规则', width: '' },
      { prop: 'questionNum', label: '题目总数', width: '100px' },
      { prop: 'totolScore', label: '合计分值', width: '100px' },
      {
        label: '操作',
        buttons: setTableButtons(['编辑', '删除'])
      }
    ],
    paperModel: {
      title: (params) => {
        return params.pageStatus === 'add'
          ? '新增试卷模版'
          : params.pageStatus === 'edit'
          ? '编辑试卷模版'
          : ''
      },
      width: '720px',
      addFun: 'dictionary/addCreatePaperModel',
      editFun: 'dictionary/editCreatePaperModel',
      getParentFun: 'dictionary/getCreatePaperModel',
      formParams: {
        uid: '',
        templateUid: '',
        templateName: '',
        questionRules: [
          { questionType: '', questionNum: null, score: null }
        ]
      },
      formRules: {
        templateName: [
          {
            required: true,
            message: '请输入试卷模版名称',
            trigger: 'blur'
          }
        ],
        questionRules: [
          {
            required: true,
            message: '请至少添加一种题型',
            trigger: 'change',
            type: 'array'
          },
          {
            validator: () => {
              return (rule, value, callback) => {
                if (!value || !value.length) {
                  callback('请至少添加一种题型')
                  return
                }
                const types = []
                for (let i = 0; i < value.length; i++) {
                  const row = value[i] || {}
                  if (!row.questionType) {
                    callback('第' + (i + 1) + '行请选择题型')
                    return
                  }
                  if (types.indexOf(row.questionType) > -1) {
                    callback('题型「' + row.questionType + '」重复')
                    return
                  }
                  types.push(row.questionType)
                  const num = Number(row.questionNum)
                  if (!num || num <= 0 || parseInt(num, 10) !== num) {
                    callback(
                      '题型「' + row.questionType + '」的题目数量须为正整数'
                    )
                    return
                  }
                  const score = Number(row.score)
                  if (!score || score <= 0) {
                    callback(
                      '题型「' + row.questionType + '」的每题分数须大于0'
                    )
                    return
                  }
                }
                callback()
              }
            },
            trigger: 'change'
          }
        ]
      },
      formData: [
        {
          key: 'templateName',
          label: '试卷模版名称',
          type: 'input',
          placeholder: '请输入试卷模版名称',
          span: 24
        },
        {
          key: 'questionRules',
          label: '题型规则',
          type: 'table',
          editable: true,
          span: 24,
          maxHeight: 360,
          headButtons: setCheckButtons([
            { name: '添加题型', code: 'addQuestionRule' }
          ]),
          columns: [
            {
              prop: 'questionType',
              label: '题目类型',
              editType: 'select',
              options: (params) => params.dictionarys.questionType,
              minWidth: '140px'
            },
            {
              prop: 'questionNum',
              label: '题目数量',
              editType: 'input',
              number: 0,
              minWidth: '110px'
            },
            {
              prop: 'score',
              label: '每题分数',
              editType: 'input',
              number: true,
              minWidth: '110px'
            },
            {
              label: '操作',
              width: '90px',
              buttons: setTableButtons([
                { name: '移除', code: 'removeQuestionRule' }
              ])
            }
          ]
        }
      ]
    }
  },
  eduContent: {
    name: 'eduContent',
    theme: '教育内容',
    componentTypes: ['navigate', 'navBar', 'check', 'tables', 'dialogForm'],
    detailPage: [
      {
        code: 'add',
        type: 'dialogForm',
        name: 'eduContent'
      },
      {
        code: 'edit',
        type: 'dialogForm',
        name: 'eduContent',
        checkType: 'useRowData'
      }
    ],
    headButtons: (params) => {
      if (params.orgName === '甘肃大鹏鸟科技有限公司') {
        return setCheckButtons(['新增', '导入', '批量删除', '下载模板'])
      }
      return setCheckButtons([
        '新增',
        '导入',
        '同步系统默认',
        '重置为系统默认',
        '批量删除',
        '下载模板'
      ])
    },
    getListFun: 'dictionary/getEduContent',
    deleteFun: 'dictionary/deleteEduContent',
    rowKey: 'uid',
    selectColumn: true,
    selectData: [
      {
        key: 'keyword',
        label: '关键字',
        type: 'input',
        placeholder: '工程类型 / 作业类型 / 作业内容 / 教育内容',
        span: 10
      }
    ],
    queryParams: {
      keyword: ''
    },
    rowData: (params) => {
      const source = Array.isArray(params.dictionarys.eduContent)
        ? params.dictionarys.eduContent
        : []
      const keyword =
        params.queryValues && params.queryValues.keyword
          ? String(params.queryValues.keyword).trim()
          : ''
      if (!keyword) return source
      const key = keyword.toLowerCase()
      return source.filter((item) => {
        const text = [
          item.riskProType,
          item.riskWokeType,
          item.riskSource,
          item.eduContent,
          item.riskWokeCode
        ]
          .join(' ')
          .toLowerCase()
        return text.indexOf(key) >= 0
      })
    },
    columns: [
      { prop: 'riskProType', label: '工程类型', width: '140' },
      { prop: 'riskWokeType', label: '作业类型', width: '140' },
      { prop: 'riskSource', label: '作业内容', width: '160' },
      { prop: 'eduContent', label: '教育内容', width: '' },
      { prop: 'riskWokeCode', label: '作业编码', width: '120' },
      {
        label: '操作',
        buttons: setTableButtons(['编辑', '删除'])
      }
    ],
    eduContent: {
      title: (params) => {
        return params.pageStatus === 'add'
          ? '新增教育内容'
          : params.pageStatus === 'edit'
          ? '编辑教育内容'
          : ''
      },
      addFun: 'dictionary/addEduContent',
      editFun: 'dictionary/editEduContent',
      getParentFun: 'dictionary/getEduContent',
      formParams: {
        uid: '',
        orgUid: (params) => {
          return params.orgName === '甘肃大鹏鸟科技有限公司'
            ? ''
            : params.orgValue
        },
        riskProType: '',
        riskWokeType: '',
        riskSource: '',
        eduContent: '',
        riskWokeCode: '',
        sortNo: 0
      },
      formRules: {
        riskProType: [
          {
            required: true,
            message: '请输入工程类型',
            trigger: 'blur'
          }
        ],
        riskWokeType: [
          {
            required: true,
            message: '请输入作业类型',
            trigger: 'blur'
          }
        ],
        riskSource: [
          {
            required: true,
            message: '请输入作业内容',
            trigger: 'blur'
          }
        ],
        eduContent: [
          {
            required: true,
            message: '请输入教育内容',
            trigger: 'blur'
          }
        ]
      },
      formData: [
        {
          key: 'riskProType',
          label: '工程类型',
          type: 'input',
          placeholder: '一级，如隧道工程',
          span: 18
        },
        {
          key: 'riskWokeType',
          label: '作业类型',
          type: 'input',
          placeholder: '二级，如洞身开挖',
          span: 18
        },
        {
          key: 'riskSource',
          label: '作业内容',
          type: 'input',
          placeholder: '三级，如爆破',
          span: 18
        },
        {
          key: 'eduContent',
          label: '教育内容',
          type: 'input',
          inputType: 'textarea',
          placeholder: '四级，具体交底要点',
          span: 18
        },
        {
          key: 'riskWokeCode',
          label: '作业编码',
          type: 'input',
          placeholder: '可不填，系统按前三级自动生成',
          span: 18
        }
      ]
    }
  },
  standardRates: {
    name: 'standardRates',
    theme: '混凝超标标准',
    componentTypes: ['navigate', 'navBar', 'check', 'tables', 'dialogForm'],
    detailPage: [
      {
        code: 'add',
        type: 'dialogForm',
        name: 'standardRates'
      },
      {
        code: 'edit',
        type: 'dialogForm',
        name: 'standardRates',
        checkType: 'useRowData'
      }
    ],
    headButtons: (params) => {
      if (params.orgName === '甘肃大鹏鸟科技有限公司') {
        return setCheckButtons(['新增'])
      }
      return setCheckButtons(['新增', '同步系统默认', '重置为系统默认'])
    },
    getListFun: 'dictionary/getStandardRates',
    deleteFun: 'dictionary/deleteOrgDict',
    rowData: (params) => {
      return params.dictionarys.standardRates
        ? JSON.parse(JSON.stringify(params.dictionarys.standardRates))
        : []
    },
    columns: [
      { prop: 'type', label: '工程类型', width: '160' },
      { prop: 'overRate', label: '超方比例', width: '120' },
      { prop: 'overQuantity', label: '超方限量(m³)', width: '140' },
      { prop: 'addQuantity', label: '补方限量(m³)', width: '140' },
      { prop: 'superRuleCode', label: '高级审核职务', width: '160' },
      { prop: 'normalRuleCode', label: '一般审核职务', width: '' },
      {
        label: '操作',
        buttons: setTableButtons(['编辑', '删除'])
      }
    ],
    standardRates: {
      title: (params) => {
        return params.pageStatus === 'add'
          ? '新增混凝超标标准'
          : params.pageStatus === 'edit'
          ? '编辑混凝超标标准'
          : ''
      },
      addFun: 'dictionary/addOrgDict',
      editFun: 'dictionary/editOrgDict',
      getParentFun: 'dictionary/getStandardRates',
      formParams: {
        uid: '',
        orgUid: (params) => {
          return params.orgName === '甘肃大鹏鸟科技有限公司'
            ? ''
            : params.orgValue
        },
        dictCode: 'standardRates',
        type: '',
        itemKey: '',
        itemName: '',
        overRate: 0.1,
        overQuantity: 1,
        addQuantity: 1,
        superRuleCode: 'chief_engineer',
        normalRuleCode: 'minister_of_works',
        sortNo: 0
      },
      formRules: {
        type: [
          {
            required: true,
            message: '请输入工程类型，其他类型请填 other',
            trigger: 'blur'
          }
        ],
        overRate: [
          {
            required: true,
            message: '请输入超方比例',
            trigger: 'blur'
          }
        ]
      },
      formData: [
        {
          key: 'type',
          label: '工程类型',
          type: 'input',
          placeholder: '与分项工程类型一致，兜底填 other',
          span: 18
        },
        {
          key: 'overRate',
          label: '超方比例',
          type: 'input',
          number: true,
          placeholder: '小数，如 0.2 表示超方 20%',
          span: 18
        },
        {
          key: 'overQuantity',
          label: '超方限量(m³)',
          type: 'input',
          number: true,
          span: 18
        },
        {
          key: 'addQuantity',
          label: '补方限量(m³)',
          type: 'input',
          number: true,
          span: 18
        },
        {
          key: 'superRuleCode',
          label: '高级审核职务',
          type: 'select',
          options: [
            { value: 'chief_engineer', label: '总工 chief_engineer' },
            { value: 'minister_of_works', label: '工管部长 minister_of_works' }
          ],
          span: 18
        },
        {
          key: 'normalRuleCode',
          label: '一般审核职务',
          type: 'select',
          options: [
            { value: 'chief_engineer', label: '总工 chief_engineer' },
            { value: 'minister_of_works', label: '工管部长 minister_of_works' }
          ],
          span: 18
        }
      ]
    }
  },
  evaluationModule: {
    name: 'evaluationModule',
    theme: '自动考评模块',
    componentTypes: ['navigate', 'navBar', 'check', 'tables', 'dialogForm'],
    detailPage: [
      {
        code: 'add',
        type: 'dialogForm',
        name: 'evaluationModule'
      },
      {
        code: 'edit',
        type: 'dialogForm',
        name: 'evaluationModule',
        checkType: 'useRowData'
      }
    ],
    headButtons: (params) => {
      if (params.orgName === '甘肃大鹏鸟科技有限公司') {
        return setCheckButtons(['新增'])
      }
      return setCheckButtons(['新增', '同步系统默认', '重置为系统默认'])
    },
    getListFun: 'dictionary/getEvaluationModule',
    deleteFun: 'dictionary/deleteOrgDict',
    rowData: (params) => {
      return params.dictionarys.evaluationModule
        ? JSON.parse(JSON.stringify(params.dictionarys.evaluationModule))
        : []
    },
    columns: [
      { prop: 'module', label: '模块编码', width: '160' },
      { prop: 'name', label: '模块名称', width: '160' },
      { prop: 'score', label: '奖励积分', width: '' },
      {
        label: '操作',
        buttons: setTableButtons(['编辑', '删除'])
      }
    ],
    evaluationModule: {
      title: (params) => {
        return params.pageStatus === 'add'
          ? '新增自动考评模块'
          : params.pageStatus === 'edit'
          ? '编辑自动考评模块'
          : ''
      },
      addFun: 'dictionary/addOrgDict',
      editFun: 'dictionary/editOrgDict',
      getParentFun: 'dictionary/getEvaluationModule',
      formParams: {
        uid: '',
        orgUid: (params) => {
          return params.orgName === '甘肃大鹏鸟科技有限公司'
            ? ''
            : params.orgValue
        },
        dictCode: 'evaluationModule',
        module: '',
        name: '',
        itemKey: '',
        itemName: '',
        score: 0,
        sortNo: 0
      },
      formRules: {
        module: [
          {
            required: true,
            message: '请输入模块编码',
            trigger: 'blur'
          }
        ],
        name: [
          {
            required: true,
            message: '请输入模块名称',
            trigger: 'blur'
          }
        ],
        score: [
          {
            required: true,
            message: '请输入奖励积分',
            trigger: 'blur'
          }
        ]
      },
      formData: [
        {
          key: 'module',
          label: '模块编码',
          type: 'input',
          placeholder: '如 onlineExam、training',
          span: 18
        },
        {
          key: 'name',
          label: '模块名称',
          type: 'input',
          span: 18
        },
        {
          key: 'score',
          label: '奖励积分',
          type: 'input',
          number: true,
          span: 18
        }
      ]
    }
  },
  fieldMenu: {
    name: 'fieldMenu',
    theme: '机构可配字段',
    componentTypes: ['navigate', 'navBar', 'check', 'tables', 'dialogForm'],
    detailPage: [
      {
        code: 'edit',
        type: 'dialogForm',
        name: 'fieldMenu',
        checkType: 'useRowData'
      }
    ],
    headButtons: [],
    getListFun: 'dictionary/getSysFieldMenu',
    rowData: (params) => {
      var list = params.dictionarys.fieldMenu
        ? JSON.parse(JSON.stringify(params.dictionarys.fieldMenu))
        : []
      return list.map((item) => {
        item.orgVisibleText = item.orgVisible === '1' ? '是' : '否'
        return item
      })
    },
    columns: [
      { prop: 'fieldName', label: '字段名称', width: '180' },
      { prop: 'fieldCode', label: '字段编码', width: '180' },
      { prop: 'orgVisibleText', label: '机构可配', width: '' },
      {
        label: '操作',
        buttons: setTableButtons(['编辑'])
      }
    ],
    fieldMenu: {
      title: '编辑机构可配字段',
      editFun: 'dictionary/editSysFieldMenu',
      getParentFun: 'dictionary/getSysFieldMenu',
      formParams: {
        uid: '',
        fieldCode: '',
        fieldName: '',
        orgVisible: '0',
        sortNo: 0
      },
      formRules: {
        fieldName: [
          {
            required: true,
            message: '请输入字段名称',
            trigger: 'blur'
          }
        ]
      },
      formData: [
        {
          key: 'fieldName',
          label: '字段名称',
          type: 'input',
          span: 18
        },
        {
          key: 'fieldCode',
          label: '字段编码',
          type: 'input',
          disabled: true,
          span: 18
        },
        {
          key: 'orgVisible',
          label: '机构可配',
          type: 'select',
          disabled: (params) => {
            return params.formValues && params.formValues.fieldCode === 'fieldMenu'
          },
          options: [
            { value: '1', label: '是' },
            { value: '0', label: '否' }
          ],
          span: 18
        }
      ]
    }
  }
}

export default fields
